import PropTypes from "prop-types";
import { useCurrentRoute } from "components/hooks/useCurrentRoute";
import { processAPILink } from "utils/processAPILink";

// Uses the render-props pattern to take a API link, appends referrer to the
// URL and transforms the elements ready for rendering into a normal <a>
// link by spreading the properties onto the link element (or a styled
// variation).
//
// Note: Should be used with AccessibleLinkContent to render "opens in new
// window" message automatically.
//
// This is a low-level UI component. Consider using an alternative like
// AccessibleAPILink or BlueButtonLink (which do this work by default) or
// implementing a variation.
//
// Example:
//  <WithAPILink urlID="SOME_API_LINK_ID">
//    {link => (
//      <TransformsAPILink link={link}>
//        {({ props, name, showNewWindow }) => (
//          <a {...props}>
//            <AccessibleLinkContent
//              link={link}
//              showNewWindow={showNewWindow}
//             />
//          </a>
//        )
//      </TransformsAPILink>
//    )}
//  <WithAPILink>
export default function TransformsAPILink({
  children,
  link,
  urlParameters = false,
}) {
  const currentRoute = useCurrentRoute();

  if (link) {
    const processedLink = processAPILink(currentRoute, urlParameters)(link);
    return children(processedLink);
  }

  return null;
}

TransformsAPILink.propTypes = {
  children: PropTypes.func,
  link: PropTypes.shape({
    disabled: PropTypes.bool,
    name: PropTypes.string,
    title: PropTypes.string,
    showNewWindow: PropTypes.bool,
    ucFrom: PropTypes.string,
    ucUpdateCache: PropTypes.string,
    url: PropTypes.string,
    urlId: PropTypes.string,
  }),
  urlParameters: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
};
